import React from 'react';
import { motion } from 'framer-motion';

const Impressum = () => {
  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-xl"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Impressum</h1>
          
          <div className="space-y-8 text-slate-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Angaben gemäß § 5 TMG</h2>
              <p>
                MK Netzbau GmbH<br />
                Burger Hauptstraße 14B<br />
                35745 Herborn
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Vertreten durch</h2>
              <p>
                Geschäftsführer: Malik Kömeagac
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Kontakt</h2>
              <p>
                Telefon: +49 176 2278 71 28<br />
                E-Mail: <a href="mailto:info@mk-netzbau.de" className="text-amber-600 hover:text-amber-700">info@mk-netzbau.de</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Umsatzsteuer-ID</h2>
              <p>
                Steuernummer: 02023963174
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Impressum;